import { getZones } from '../../services/journal/zones.service'

// MF-67 — Journal zones list slice.
export const UPDATE_JOURNAL_ZONES_LIST = 'UPDATE_JOURNAL_ZONES_LIST'
export const TOGGLE_JOURNAL_ZONES_LOADING = 'TOGGLE_JOURNAL_ZONES_LOADING'
export const JOURNAL_ZONES_ERROR = 'JOURNAL_ZONES_ERROR'
export const JOURNAL_ZONES_UPDATE_TOTAL = 'JOURNAL_ZONES_UPDATE_TOTAL'

export const updateZonesList = (value = []) => ({
  type: UPDATE_JOURNAL_ZONES_LIST,
  payload: { value }
})

export const zonesError = (value = null) => ({
  type: JOURNAL_ZONES_ERROR,
  payload: { value }
})

export const toggleLoadingZones = (value = false) => ({
  type: TOGGLE_JOURNAL_ZONES_LOADING,
  payload: { value }
})

export const updateTotalZones = (value = 0) => ({
  type: JOURNAL_ZONES_UPDATE_TOTAL,
  payload: { value }
})

export const loadZones = (params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingZones(true))
      dispatch(zonesError())

      const { data } = await getZones(params)

      dispatch(updateZonesList(data?.paginatedResults ?? []))
      dispatch(updateTotalZones(data?.totalRecords ?? 0))
    } catch (error) {
      dispatch(updateZonesList([]))
      dispatch(updateTotalZones(0))
      dispatch(zonesError(error?.message ?? 'error'))
    } finally {
      dispatch(toggleLoadingZones(false))
    }
  }
}
